import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UsersTypesPage = lazy(() => import('../views/list/UsersTypesPage'));

export function UsersTypesPageLazy() {
	return (
		<PageSuspense>
			<UsersTypesPage />
		</PageSuspense>
	);
}
